import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Overview from "../components/Overview";
import Cities from "../components/Cities";
import CalendarView from "../components/CalendarView";
import Itinerary from "../components/Itinerary";
import Pricing from "../components/Pricing";
import Guide from "../components/Guide";
import Reserve from "../components/Reserve";
import Footer from "../components/Footer";

const Landing = () => {
  return (
    <div className="font-body bg-[#faf5ec] text-[#1f2d27] min-h-screen">
      <Navbar />
      <Hero />
      <Overview />
      <Cities />
      <CalendarView />
      <Itinerary />
      <Pricing />
      <Guide />
      <Reserve />
      <Footer />
    </div>
  );
};

export default Landing;
